export class BtnOptionExtend{
    constructor(
        public text: string, // tên text
        public icon?: string | null, // loại icon
        public handler?: Handler | null, // xử lý sự kiện
        public nzType?: Nztype | null,
        public nzDanger?: boolean | null,
        public znTheme?: Nztheme | null, // loại theme
        public className?: string | null, // thêm class 
        public disabled?: boolean | null, //disabled
        public iconFontAweSome?: string | null, // icon font AweSome
        ) {}
}

export enum Nztheme{
    OUTLINE = 'outline',
    FILL = 'fill',
    TWOTONE = 'twotone'
}

export enum Nztype{
    PRIMARY = 'primary', 
    DASHED = 'dashed',
    TEXT = 'text',
    LINK = 'link',
}

type Handler = () => void;